// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"831fdf6d","313":"831fdf6d","590":"831fdf6d","754":"831fdf6d","805":"831fdf6d","897":"831fdf6d","971":"831fdf6d"}[chunkId] + ".chunk.css";
};